import HTTP from '../utils/http'
import LogProvider from '../classes/log-provider'
import TaskPool from '../classes/task-pool'
import { uniqueString } from '../utils/string'

const SPLUNK_ENDPOINT = '/splunk'

const _url = uniqueString('SplunkProvider_url')
const _httpPool = uniqueString('SplunkProvider_httpPool')
const _meta = uniqueString('SplunkProvider_meta')

export default class SplunkProvider extends LogProvider {
  static get is() {
    return 'SplunkProvider'
  }

  constructor(config) {
    super(config)

    this[_url] = config.splunkUrl || SPLUNK_ENDPOINT
    this[_httpPool] = new TaskPool()
    this[_meta] = config.batchMeta
  }

  onBatch(batch, meta = {}) {
    return HTTP({
      url: this[_url],
      data: this._createRequest(batch),
      beacon: meta.manual,
    })
  }

  _createRequest(logs) {
    const request = {
      logs: logs.map((log) => log.serialize()),
      timestamp: new Date(),
    }

    if (this[_meta]) {
      return {
        ...request,
        ...this[_meta],
      }
    }

    return request
  }
}
